module.exports = __webpack_public_path__ + "static/img/mobile-invoice.62e2a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile-invoice.png
// module id = NWTx
// module chunks = 73